import React, { FC, MouseEvent } from "react";
import { shallowEqual } from "react-redux";
import { useAppDispatch } from "../../../store/hooks/dispatch.hook";
import { useAppSelector } from "../../../store/hooks/selector.hook";
import { getServicesListFetch, setPageServices } from "../../../store/state/services/service/service.slice";
import Basics from "./Basics";
import { BasicsColumn } from "./models/BasicsColumn";
import { Filter } from "../../../utl/models/Filters";
import usePagination from "../../../utl/hooks/usePagination";
import culcPageTable from "../../../utl/helpers/culcPageTable";

interface Props {
    data: BasicsColumn[];
    handleClickRow: (item: any, event: MouseEvent<HTMLTableRowElement>) => void;
    vendorId: number;
}

const BasicsPagination: FC<Props> = ({ data, handleClickRow, vendorId }) => {
    const dispatch = useAppDispatch();

    const typeId = useAppSelector(state => state.services.filter.typeId, shallowEqual);
    const categoryId = useAppSelector(state => state.services.filter.categoryId, shallowEqual);
    const confirmed = useAppSelector(state => state.services.filter.confirmed, shallowEqual);
    const active = useAppSelector(state => state.services.filter.active, shallowEqual);

    const page = useAppSelector(state => state.services.page, shallowEqual);
    const totalCount = useAppSelector(state => state.services.totalCount, shallowEqual);
    const pageAll = useAppSelector(state => state.services.pageAll, shallowEqual);
    const pageSize = useAppSelector(state => state.services.pageSize, shallowEqual);
    const getAllItems = useAppSelector(state => state.services.getAllItems, shallowEqual);

    const setPage = (filter: Filter | undefined, pageNumber: number) => {
        dispatch(getServicesListFetch({ vendorId, filter }));
        dispatch(setPageServices({ page: pageNumber }));
    };

    const pagination = usePagination({
        getAllItems,
        pageAll,
        page,
        totalCount,
        pageSize,
        setPage,
        typeId,
        categoryId,
        confirmed,
        active,
    });

    const pagesRange = pagination.pagesRange;

    const pageTable = culcPageTable<BasicsColumn>(data, pagesRange.from, pagesRange.to);

    return (
        <Basics
            handleClickRow={handleClickRow}
            data={pageTable}
            page={page}
            pages={pagination.pages}
            handleLeftButtonPagination={pagination.handleLeftButtonPagination}
            handleRightButtonPagination={pagination.handleRightButtonPagination}
        />
    );
}

export default BasicsPagination;